export enum ClinicServiceDeliveryModel {
  SaaS = 'SaaS',
  FullyManaged = 'Fully Managed',
}
